import React, { Component } from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import DeviceCard from '../elements/DeviceCard';
import Button from '../elements/Button';
import SendButton from '../elements/SendButton';
import Heading from '../elements/PageHeading';
import Paragraph from '../elements/Paragraph';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: auto;
  color: ${props => props.theme.secondary};
`;

const Notice = styled.div`
  margin: 0.5em auto 1em;
  padding: 0.6em 1em;
  max-width: 420px;
  text-align: center;
  background: ${props => props.theme.positiveTint || '#e6f4ea'};
  border-radius: 4px;
`;

const LaneForm = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px auto 0px;
  min-width: 280px;

  label {
    margin-top: 10px;
    margin-bottom: 4px;
  }

  select,
  input {
    padding: 6px;
    font-size: 1em;
  }
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px auto 0px;
  align-items: center;
`;

/**
 * scale2 tare mode: tares every weight lane of the cabinet. The cabinet screen shows the instructions,
 * the progress and the per-lane result; this page only starts and stops the mode.
 */
class Scale2TarePage extends Component {
  state = { shelf: '', slot: '' };

  /** { shelfId, slotId } when both fields hold a valid position, otherwise null (single-lane button disabled) */
  target() {
    const { shelf, slot } = this.state;
    if (shelf === '' || slot === '') return null;
    const shelfId = Number(shelf);
    const slotId = Number(slot);
    if (!Number.isInteger(shelfId) || !Number.isInteger(slotId) || slotId < 0)
      return null;
    return { shelfId, slotId };
  }

  render() {
    const {
      t,
      target,
      cancel,
      startTare,
      tareLanes,
      stopTare,
      message,
    } = this.props;

    return (
      <Wrapper>
        <Heading text={t('management.scale2_tare')} />
        <DeviceCard device={target || {}} />
        <Paragraph>{t('management.scale2_tare_instruction')}</Paragraph>
        <Paragraph>{t('management.scale2_screen_note')}</Paragraph>
        {message && <Notice>{t(message)}</Notice>}
        <Buttons>
          <Button onClick={cancel}>{t('button.cancel')}</Button>
          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
          <SendButton
            chevron={false}
            feedback
            onClick={() => startTare()}
            text={t('button.startTare')}
          />
          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
          <SendButton
            chevron={false}
            feedback
            onClick={() => tareLanes(null)}
            text={t('button.tareLanes')}
          />
          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
          <SendButton
            chevron={false}
            feedback
            onClick={() => stopTare()}
            text={t('button.stopTare')}
          />
        </Buttons>
        <LaneForm>
          <Paragraph>{t('management.scale2_tare_position_hint')}</Paragraph>
          <label htmlFor="scale2-tare-shelf">
            {t('management.scale2_shelf')}
          </label>
          <input
            id="scale2-tare-shelf"
            type="number"
            min="1"
            step="1"
            value={this.state.shelf}
            onChange={event => this.setState({ shelf: event.target.value })}
          />
          <label htmlFor="scale2-tare-slot">
            {t('management.scale2_slot')}
          </label>
          <input
            id="scale2-tare-slot"
            type="number"
            min="0"
            step="1"
            value={this.state.slot}
            onChange={event => this.setState({ slot: event.target.value })}
          />
          <Buttons>
            <SendButton
              chevron={false}
              feedback
              disabled={this.target() === null}
              onClick={() => tareLanes(this.target())}
              text={t('button.tareLane')}
            />
          </Buttons>
        </LaneForm>
      </Wrapper>
    );
  }
}

export default translate()(Scale2TarePage);
